import React, { useEffect, useState, useRef, createContext } from "react";
import { Col, Row } from "react-bootstrap";
import "../Spot/Spot.css";

import axios from "axios";
import SockJS from "sockjs-client";
import Stomp from "stompjs";
import FutureLeftTable from "./FutureLeftTable";
import FutureTVChart from "./FututeTVChart";
import FututeDepthChart from "./FutureDepthChart";
import FutureRightTable from "./FutureRightTable";
import FutureBottomTable from "./FutureBottomTable";
import FutureBuyAndSell from "./FutureBuySell";
import FlipNumbers from "react-flip-numbers";
import { WEBSERVICE, checkInternetConnection } from "../../CoreDataService";
import { Box, Typography, alpha } from "@mui/material";
import ShowChartOutlinedIcon from "@mui/icons-material/ShowChartOutlined";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import TrendingDownOutlinedIcon from "@mui/icons-material/TrendingDownOutlined";
import { useSelector } from "react-redux";

export const FutureDataContent = createContext();

const FuturesDashboard = () => {
  const theme = localStorage.getItem("theme");
  const { btncolor } = useSelector((state) => state);
  const [isConnected, setIsConnected] = useState(true);
  const [activeButton, setActiveButton] = useState("Price");
  const [data, setData] = useState({});
  const [title, setTitle] = useState("angulartitle");
  const [chartData, setChartData] = useState(null);
  const [ltp, setLtp] = useState(null);
  const [markPrice, setMarkPrice] = useState(null);
  const [indexPrice, setIndexPrice] = useState(null);
  const [rocData, setRocData] = useState(0);
  const [volumnData, setVolumnData] = useState(0);
  const [lowPrice, setLowPrice] = useState(0);
  const [highPrice, setHighPrice] = useState(0);
  const [action, setAction] = useState("");
  const [isNegative, setIsNegative] = useState(false);
  const [isRocReact, setIsRocReact] = useState(false);
  const [themeColor, setThemeColor] = useState("light");
  const [finalBiddata, setFinalBiddata] = useState([]);
  const [finalAskdata, setFinalAskdata] = useState([]);
  const [lastAskItem, setLastAskItem] = useState(null);
  const [firstBidItem, setFirstBidItem] = useState(null);
  const [derivativeAssets, setDerivativeAssets] = useState();
  const [updateBalance, setUpdateBalance] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [currencycode, setCurrencycode] = useState(
    localStorage.getItem("derivative_buying_crypto_asset") || "BTC"
  );
  const [basecurrency, setBasecurrency] = useState("USDT");

  const [assetpair, setAssetPair] = useState(
    localStorage.getItem("selected_derivative_asset_pair") || "BTCUSDT_PERP"
  );
  const [assetPairName, setAssetPairName] = useState(
    localStorage.getItem("selected_derivative_asset_pair_name") ||
      "BTCUSDT Perpetual"
  );

  const [balanceList, setBalanceList] = useState([]);
  const [currencyBalance, setCurrencyBalance] = useState([]);
  const [newFiatArray, setNewFiatArray] = useState([]);

  const [message, setMessage] = useState(null); // Store received messages
  const [connected, setConnected] = useState(false); // Connection status
  const stompClientRef = useRef(null); // Store the Stomp client instance
  const [buyingAsset, setBuyingAsset] = useState(
    localStorage.getItem("buying_crypto_asset") || "BTC"
  );
  const [sellingAsset, setSellingAsset] = useState(
    localStorage.getItem("selling_crypto_asset") || "USD"
  );
  const [sellData, setSellData] = useState("");
  const [buyData, setBuyData] = useState("");

  const allProps = {
    chartData,
    setFinalBiddata,
    setFinalAskdata,
    setCurrencycode,
    setBasecurrency,
    currencycode,
    basecurrency,
    setAssetPair,
    lowPrice,
    highPrice,
    assetpair,
    setAssetPairName,
    setDerivativeAssets,
    refresh,
    newFiatArray,
    finalBiddata,
    finalAskdata,
    lastAskItem,
    firstBidItem,
    setLastAskItem,
    setFirstBidItem,
    ltp,
    assetPairName,
    assetpair,
    derivativeAssets,
    updateBalance,
    setRefresh,
    setSellData,
    setBuyData,
    sellData,
    buyData,
    setUpdateBalance,
  };

  const [reqNo, setReqNo] = useState(Math.floor(Math.random() * 1000) + 1);
  const websocketRef = useRef(null);
  const webSocketEndPoint =
    "https://futures-stream.paybito.com/fSocketStream/ws";
  const topic = "/user/topic/stream";
  let stompClient = null;

  const changeMessage = (msg) => {
    setMessage(msg);
  };

  const connectWebSocket = () => {
    const accessToken = localStorage.getItem("access_token");
    if (accessToken) {
      const ws = new SockJS(webSocketEndPoint);
      stompClientRef.current = Stomp.over(ws);
      stompClientRef.current.debug = null;

      stompClientRef.current.connect(
        {},
        (frame) => {
          if (stompClientRef.current && stompClientRef.current.connected) {
            stompClientRef.current.subscribe(topic, (sdkEvent) => {
              onMessageReceived(sdkEvent);
            });
            subscribe(); // Ensure this doesn't rely on an unready connection
          } else {
            console.error("STOMP connection not ready yet.");
          }
        },
        errorCallback
      );
    }
  };

  const errorCallback = (error) => {
    if (localStorage.getItem("access_token")) {
      setTimeout(() => {
        connectWebSocket();
      }, 5000);
    }
  };

  const sendMessage = (message) => {
    if (!stompClientRef.current || !stompClientRef.current.connected) {
      console.error("WebSocket is not connected yet.");
      return;
    }

    stompClientRef.current.send(
      "/app/sendRequest",
      {},
      JSON.stringify(message)
    );
  };

  const onMessageReceived = (message) => {
    const parsedMessage = JSON.parse(message.body);
    console.log("socketData", assetpair, parsedMessage);
    changeMessage(parsedMessage); // Store message
    const data = parsedMessage.tR;
    if (data !== null) {
      setChartData(data);
      // setMarkPrice(parseFloat(data?.markPrice)?.toFixed(2));
      // setIndexPrice(parseFloat(data?.indexPrice)?.toFixed(2));
      setLowPrice(parseFloat(data?.lowPrice)?.toFixed(2));
      setHighPrice(parseFloat(data?.highPrice)?.toFixed(2));
      setAction(data?.action);
      setRocData(parseFloat(data?.roc).toFixed(2));
      setVolumnData(parseFloat(data?.volume).toFixed(2));
      setIsRocReact(data?.roc > 0);
      setIsNegative(data?.roc < 0);
      setTitle(
        `${data?.ltp} | ${buyingAsset}${sellingAsset} | ${data?.exchange}`
      );
    }
  };

  const subscribe = () => {
    const assetPair = localStorage
      .getItem("selected_derivative_asset_pair")
      ?.toLowerCase();
    localStorage.setItem("lastAssetPair", assetPair);

    const ticker = "@ticker";
    const depth = "@depth";
    const trade = "@trade";
    const reqNo = Math.floor(Math.random() * 1000) + 1;

    const req = {
      method: "SUBSCRIBE",
      params: [assetpair + ticker, assetpair + depth, assetpair + trade],
      id: reqNo,
    };
    setTimeout(() => {
      sendMessage(req);
    }, 10000);
  };

  const disconnectWebSocket = () => {
    if (stompClientRef.current && stompClientRef.current.connected) {
      stompClientRef.current.disconnect(() => {
        console.log("Disconnected");
      });
    } else {
      console.warn("Disconnect skipped: STOMP client not connected.");
    }
  };

  useEffect(() => {
    fetchTickerData();

    return () => {
      if (websocketRef.current) {
        disconnectWebSocket(); // Disconnect WebSocket when the component unmounts
      }
      disconnectWebSocket();
    };
  }, [assetpair, currencycode]);
  useEffect(() => {
    getUserBalance();
  }, [assetpair, currencycode]);

  useEffect(() => {
    // Call the function and get the cleanup function
    const cleanup = checkInternetConnection(setIsConnected);

    // Cleanup listeners when component unmounts
    return () => cleanup();
  }, []);

  const fetchTickerData = () => {
    let selectedPair = localStorage.getItem("selected_derivative_asset_pair");
    let selectedPairName = localStorage.getItem(
      "selected_derivative_asset_pair_name"
    );

    if (!selectedPair || !selectedPairName) {
      selectedPair = "BTCUSDT_PERP";
      selectedPairName = "BTCUSDT Perpetual";
      localStorage.setItem("selected_derivative_asset_pair", selectedPair);
      localStorage.setItem(
        "selected_derivative_asset_pair_name",
        selectedPairName
      );
    }

    axios
      .get(
        `https://futures-stream.paybito.com/fSocketStream/api/get24hTicker?assetPair=${assetpair}`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      )
      .then((response) => {
        const result = response.data;
        if (result && result.length) {
          const data = result[0];
          setChartData(data);
          setMarkPrice(parseFloat(data.markPrice).toFixed(2));
          setIndexPrice(parseFloat(data.indexPrice).toFixed(2));
          setLtp(data?.ltp);
          setLowPrice(parseFloat(data.lowPrice).toFixed(2));
          setHighPrice(parseFloat(data.highPrice).toFixed(2));
          setAction(data.action);
          setRocData(parseFloat(data.roc).toFixed(2));
          setVolumnData(parseFloat(data.volume).toFixed(2));
          setIsRocReact(data.roc > 0);
          setIsNegative(data.roc < 0);
          setTitle(`${data?.ltpdata} | BTCUSDT Perpetual | ${data?.exchange}`);
        }

        // websocketRef.current = {
        //   socket: null,
        //   subscribeMessage: null,
        // };

        disconnectWebSocket();

        connectWebSocket();

        // websocketRef.current.subscribeMessage = (message) => {
        //   console.log("socketData message---->", assetpair, message);
        //   const data = message.tR;

        //   if (data !== null) {
        //     setChartData(data);
        //     // setMarkPrice(parseFloat(data?.markPrice)?.toFixed(2));
        //     // setIndexPrice(parseFloat(data?.indexPrice)?.toFixed(2));
        //     setLowPrice(parseFloat(data?.lowPrice)?.toFixed(2));
        //     setHighPrice(parseFloat(data?.highPrice)?.toFixed(2));
        //     setAction(data?.action);
        //     setRocData(parseFloat(data?.roc).toFixed(2));
        //     setVolumnData(parseFloat(data?.volume).toFixed(2));
        //     setIsRocReact(data?.roc > 0);
        //     setIsNegative(data?.roc < 0);
        //     setTitle(
        //       `${data?.ltp} | ${buyingAsset}${sellingAsset} | ${data?.exchange}`
        //     );
        //   }
        // };
      })
      .catch((error) => {
        console.error("Error fetching 24h ticker data manually:", error);
      });
  };

  console.log("chartData", chartData?.ltp, assetpair);

  const handleButtonClick = (button) => {
    setActiveButton(button);
  };

  const getUserBalance = async () => {
    const userTransObj = {
      customerId: localStorage.getItem("user_id"),
      uuid: localStorage.getItem("uuid"),
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}transaction/getUserBalance`,
        JSON.stringify(userTransObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const result = response.data;
      const list = result.userBalanceList;
      setBalanceList(list);
      setCurrencyBalance(list);

      if (list != null) {
        const fiatCurrencies = list
          .filter((item) => item.currencyType === 1)
          .map((item) => item.currencyCode);

        setNewFiatArray(fiatCurrencies);
        console.log("new fiat data", fiatCurrencies);
      }
    } catch (error) {
      console.warn("Error fetching balance:", error.message);
    }
  };

  return (
    <FutureDataContent.Provider value={allProps}>
      <Box sx={pageWrapper}>

        {/* ── Ticker Strip ── */}
        <Box sx={tickerStrip}>

          {/* Left — Pair badge */}
          <Box sx={tickerPairBadge}>
            <Box sx={tickerPairIconWrap}>
              <ShowChartOutlinedIcon sx={{ fontSize: 15, color: "#fff" }} />
            </Box>
            <Box>
              <Typography sx={tickerPairText}>
                {assetPairName}
              </Typography>
              <Typography sx={tickerPairSub}>Futures</Typography>
            </Box>
          </Box>

          {/* Center — Stats */}
          <Box sx={tickerStatsCenter}>
            <Box sx={tickerDivider} />

            {/* Last Price */}
            <Box sx={tickerStat}>
              <Typography sx={tickerStatLabel}>LAST PRICE</Typography>
              <Typography sx={{ ...tickerStatValue, color: isNegative ? "#F5475D" : "#21CB80", fontWeight: 800, fontSize: "1rem" }}>
                <FlipNumbers
                  height={14}
                  width={9}
                  play
                  duration={2}
                  numbers={Number(chartData?.ltp).toLocaleString(undefined, {
                    minimumFractionDigits: 6,
                    maximumFractionDigits: 6,
                  })}
                />
              </Typography>
            </Box>

            <Box sx={tickerDivider} />

            {/* MTM (Mark Price) */}
            <Box sx={tickerStat}>
              <Typography sx={tickerStatLabel}>MTM</Typography>
              <Typography sx={tickerStatValue}>{markPrice}</Typography>
            </Box>

            <Box sx={tickerDivider} />

            {/* Index Price */}
            <Box sx={tickerStat}>
              <Typography sx={tickerStatLabel}>INDEX</Typography>
              <Typography sx={tickerStatValue}>{indexPrice}</Typography>
            </Box>

            <Box sx={tickerDivider} />

            {/* 24H Change */}
            <Box sx={tickerStat}>
              <Typography sx={tickerStatLabel}>24H CHANGE</Typography>
              <Box sx={{ display: "flex", alignItems: "center", gap: "3px" }}>
                {isNegative
                  ? <TrendingDownOutlinedIcon sx={{ fontSize: 13, color: "#F5475D" }} />
                  : <TrendingUpOutlinedIcon sx={{ fontSize: 13, color: "#21CB80" }} />}
                <Typography sx={{ ...tickerStatValue, color: isNegative ? "#F5475D" : "#21CB80" }}>
                  {rocData}%
                </Typography>
              </Box>
            </Box>

            <Box sx={tickerDivider} />

            {/* 24H Volume */}
            <Box sx={tickerStat}>
              <Typography sx={tickerStatLabel}>24H VOL</Typography>
              <Typography sx={tickerStatValue}>{volumnData}</Typography>
            </Box>

            <Box sx={tickerDivider} />

            {/* 24H High */}
            <Box sx={tickerStat}>
              <Typography sx={tickerStatLabel}>24H HIGH</Typography>
              <Typography sx={{ ...tickerStatValue, color: "#21CB80" }}>{highPrice}</Typography>
            </Box>

            <Box sx={tickerDivider} />

            {/* 24H Low */}
            <Box sx={tickerStat}>
              <Typography sx={tickerStatLabel}>24H LOW</Typography>
              <Typography sx={{ ...tickerStatValue, color: "#F5475D" }}>{lowPrice}</Typography>
            </Box>

            <Box sx={tickerDivider} />
          </Box>

          {/* Right — Connection status */}
          <Box sx={tickerConnectionWrap}>
            <Box sx={tickerConnectionPill}>
              <Box
                sx={{
                  width: 6, height: 6, borderRadius: "50%", flexShrink: 0,
                  backgroundColor: isConnected ? "#21CB80" : "#F5475D",
                  boxShadow: isConnected ? "0 0 5px #21CB80" : "0 0 5px #F5475D",
                  animation: isConnected ? "tickerPulse 2s ease-in-out infinite" : "none",
                }}
              />
              <Typography sx={{ fontSize: "0.7rem", fontWeight: 700, color: isConnected ? "#21CB80" : "#F5475D", letterSpacing: "0.06em" }}>
                {isConnected ? "LIVE" : "OFFLINE"}
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* ── Main Trading Layout ── */}
        <Box sx={tradingLayout}>
          <Row className="LetfTable" style={{ margin: 0, flex: 1 }}>

            {/* Left Order Book */}
            <Col xs={12} sm={12} md={2} className="mb-1 position-relative p-0 orderbooktable">
              <Box sx={panelCard}>
                <FutureLeftTable />
              </Box>
            </Col>

            {/* Chart + Buy/Sell */}
            <Col xs={12} sm={12} md={8} className="mb-1 px-1 spotchart">
              <Box sx={{ ...panelCard, height: "auto" }}>
                {/* Chart toggle buttons */}
                <Box sx={chartToggleWrap}>
                  <Box
                    sx={{
                      ...chartToggleBtn,
                      backgroundColor: activeButton === "Price"
                        ? alpha(btncolor || "#1976d2", 0.15)
                        : "transparent",
                      color: activeButton === "Price"
                        ? btncolor || "#1976d2"
                        : "var(--text-color)",
                      borderColor: activeButton === "Price"
                        ? alpha(btncolor || "#1976d2", 0.4)
                        : "rgba(125,125,125,0.2)",
                      fontWeight: activeButton === "Price" ? 700 : 500,
                    }}
                    onClick={() => handleButtonClick("Price")}
                  >
                    <ShowChartOutlinedIcon sx={{ fontSize: 14 }} />
                    Price
                  </Box>
                  <Box
                    sx={{
                      ...chartToggleBtn,
                      backgroundColor: activeButton === "Depth"
                        ? alpha(btncolor || "#1976d2", 0.15)
                        : "transparent",
                      color: activeButton === "Depth"
                        ? btncolor || "#1976d2"
                        : "var(--text-color)",
                      borderColor: activeButton === "Depth"
                        ? alpha(btncolor || "#1976d2", 0.4)
                        : "rgba(125,125,125,0.2)",
                      fontWeight: activeButton === "Depth" ? 700 : 500,
                    }}
                    onClick={() => handleButtonClick("Depth")}
                  >
                    <BarChartOutlinedIcon sx={{ fontSize: 14 }} />
                    Depth
                  </Box>
                </Box>

                {activeButton === "Price" ? <FutureTVChart /> : <FututeDepthChart />}
              </Box>

              <Box sx={{ ...panelCard, mt: "6px", height: "auto" }}>
                <FutureBuyAndSell />
              </Box>
            </Col>

            {/* Right Order Book */}
            <Col xs={12} sm={12} md={2} className="mb-1 p-0 orderbooktable">
              <Box sx={panelCard}>
                <FutureRightTable />
              </Box>
            </Col>

            {/* Bottom Table */}
            <Col xs={12} md={12} className="mb-4 p-0">
              <Box sx={{ ...panelCard, mt: "6px" }}>
                <FutureBottomTable />
              </Box>
            </Col>

          </Row>
        </Box>

      </Box>
    </FutureDataContent.Provider>
  );
};

// ── Styles ────────────────────────────────────────────────────────────────────

const pageWrapper = {
  backgroundColor: "var(--body-color)",
  color: "var(--text-color)",
  minHeight: "100vh",
  zoom: "90%",
};

const tickerStrip = {
  display: "flex",
  alignItems: "center",
  flexWrap: "nowrap",
  px: { xs: 2, md: "14px" },
  py: "10px",
  mb: "6px",
  backgroundColor: "var(--body-color-less)",
  borderBottom: "1px solid rgba(125,125,125,0.18)",
  position: "relative",
};

const tickerStatsCenter = {
  flex: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 0,
  overflow: "hidden",
};

const tickerPairBadge = {
  display: "flex",
  alignItems: "center",
  gap: "10px",
  pr: { md: "20px" },
  mr: { md: "4px" },
};

const tickerPairIconWrap = {
  width: 32,
  height: 32,
  borderRadius: "8px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "rgba(125,125,125,0.18)",
  flexShrink: 0,
};

const tickerPairText = {
  fontSize: { xs: "0.95rem", md: "1rem" },
  fontWeight: 800,
  color: "var(--text-color)",
  letterSpacing: "0.02em",
  lineHeight: 1.2,
};

const tickerPairSub = {
  fontSize: "0.6rem",
  fontWeight: 600,
  color: "var(--text-color)",
  opacity: 0.4,
  textTransform: "uppercase",
  letterSpacing: "0.08em",
  lineHeight: 1,
  mt: "2px",
};

const tickerDivider = {
  width: "1px",
  height: 30,
  backgroundColor: "rgba(125,125,125,0.2)",
  mx: { xs: 0, md: "16px" },
  display: { xs: "none", md: "block" },
  flexShrink: 0,
};

const tickerStat = {
  display: "flex",
  flexDirection: "column",
  gap: "3px",
  pr: { md: "16px" },
};

const tickerStatLabel = {
  fontSize: "0.58rem",
  fontWeight: 700,
  color: "var(--text-color)",
  opacity: 0.45,
  textTransform: "uppercase",
  letterSpacing: "0.07em",
  lineHeight: 1,
};

const tickerStatValue = {
  fontSize: "0.82rem",
  fontWeight: 700,
  color: "var(--text-color)",
  lineHeight: 1.2,
  display: "flex",
  alignItems: "center",
};

const tickerConnectionWrap = {
  display: "flex",
  alignItems: "center",
  flexShrink: 0,
};

const tickerConnectionPill = {
  display: "flex",
  alignItems: "center",
  gap: "5px",
  px: "10px",
  py: "4px",
  borderRadius: "20px",
  border: "1px solid rgba(125,125,125,0.2)",
  backgroundColor: "rgba(125,125,125,0.08)",
};

const tradingLayout = {
  px: "6px",
  pb: "50px",
};

const panelCard = {
  backgroundColor: "var(--body-color-less)",
  border: "1px solid rgba(125,125,125,0.13)",
  borderRadius: "10px",
  overflow: "hidden",
  height: "100%",
};

const chartToggleWrap = {
  display: "flex",
  alignItems: "center",
  gap: "6px",
  px: "8px",
  py: "6px",
  borderBottom: "1px solid rgba(125,125,125,0.13)",
  backgroundColor: "var(--body-color-less2)",
};

const chartToggleBtn = {
  display: "inline-flex",
  alignItems: "center",
  gap: "5px",
  px: "12px",
  py: "5px",
  borderRadius: "8px",
  border: "1px solid",
  fontSize: "0.75rem",
  cursor: "pointer",
  userSelect: "none",
  transition: "all 0.15s ease",
  letterSpacing: "0.01em",
};

export default FuturesDashboard;
